function mapSuggestion(data) {
  return {
    citySlug: data.CitySlug,
    coordinates: data.Coordinate,
    boxShape: data.BoxShape,
    country: data.Country,
    description: data.Description,
    id: data.ID,
    slug: data.Slug,
    stars: data.Stars,
    term: `${data.Text}, ${data.Description}`,
    text: data.Text,
    type: data.Type,
  }
}

export function mapSuggestions(data) {
  return data.map(suggestion => mapSuggestion(suggestion))
}
